export const externalImageLoader = ({ src }: { src: string }) => {
  return src
}
